export default __webpack_public_path__ + "static/media/misc-fireplaceA-1440w.5407e1a5.webp";